import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
export var PartnershipSchema = new SimpleSchema({
    partnership: {
        type: String,
        optional: true,
        defaultValue: null
    },
    obendyWidgetUrl: {
        type: String,
        optional: true,
        defaultValue: null
    },
    obendyPixelAnalyticsUrl: {
        type: String,
        optional: true,
        defaultValue: null
    }
});
